module.exports = __webpack_public_path__ + "static/media/kaaba.6c11b0ab.svg";